import { createContext, useContext, useState, useCallback } from "react";

const KEY = "alphaapeing_chain";

export const CHAINS = {
  solana: { id: "solana", label: "Solana", short: "SOL", color: "#00E599", glyph: "◎" },
  robinhood: { id: "robinhood", label: "Robinhood Chain", short: "HOOD", color: "#CCFF00", glyph: "🪶" },
};

const ChainContext = createContext(null);

export const ChainProvider = ({ children }) => {
  const [chain, setChainState] = useState(() => localStorage.getItem(KEY) || "solana");
  const setChain = useCallback((c) => {
    localStorage.setItem(KEY, c);
    setChainState(c);
  }, []);
  return <ChainContext.Provider value={{ chain, setChain, meta: CHAINS[chain] }}>{children}</ChainContext.Provider>;
};

export const useChain = () => useContext(ChainContext) || { chain: "solana", setChain: () => {}, meta: CHAINS.solana };
